import { Link } from "react-router-dom";
import { Ear, Hand, Wind, Leaf, ArrowUpRight } from "lucide-react";
import { SectionHead } from "./SectionHead";
import { Reveal } from "./Reveal";
import { Breathing } from "./Breathing";

const PILLARS = [
  { I: Ear, t: "Prima si parla", d: "Il primo incontro può essere solo una conversazione. Nessuno strumento, finché non sei pronto." },
  { I: Hand, t: "Tu hai il controllo", d: "Concordiamo un segnale: alzi la mano e ci fermiamo. Sempre, senza bisogno di spiegare." },
  { I: Wind, t: "Sedazione cosciente", d: "Su indicazione, presso il Centro è possibile valutare il protossido d'azoto per vivere la seduta rilassati." },
  { I: Leaf, t: "Un ambiente che calma", d: "Luci morbide, tempi lenti, spiegazioni semplici. Ogni gesto annunciato prima di farlo." },
];

export const ZeroFear = () => (
  <section id="paura-zero" className="relative py-28 sm:py-40 bg-[#0F2317] overflow-hidden" data-testid="zero-fear-section">
    <div className="absolute -top-40 -left-40 w-[40rem] h-[40rem] rounded-full bg-[#3E6B48]/25 blur-3xl" />
    <div className="relative mx-auto max-w-[1400px] px-6 sm:px-10">
      <div className="grid lg:grid-cols-12 gap-16 items-start">
        <div className="lg:col-span-7">
          <SectionHead
            dark
            eyebrow="Per chi ha paura del dentista"
            lines={["La paura è", "legittima. Qui", "non devi nasconderla."]}
            intro="Molte persone rimandano per anni le cure alle gengive proprio per timore. È comprensibile — ma la parodontite non aspetta. Per questo il percorso è pensato, fin dal primo minuto, per chi è in ansia."
          />
          <div className="mt-16 grid sm:grid-cols-2 gap-x-10 gap-y-12">
            {PILLARS.map(({ I, t, d }, i) => (
              <Reveal key={t} delay={i * 0.08}>
                <div className="group" data-testid={`fear-pillar-${i}`}>
                  <span className="grid place-items-center w-12 h-12 rounded-full border border-[#86C89B]/30 text-[#86C89B] transition-colors duration-500 group-hover:bg-[#86C89B] group-hover:text-[#0F2317]">
                    <I size={19} strokeWidth={1.6} />
                  </span>
                  <h3 className="f-serif text-2xl sm:text-3xl text-[#FCFBF7] mt-5">{t}</h3>
                  <p className="text-[#FCFBF7]/60 mt-2 leading-relaxed text-sm sm:text-base">{d}</p>
                </div>
              </Reveal>
            ))}
          </div>
          <Reveal delay={0.2}>
            <Link to="/paura-del-dentista" data-testid="zero-fear-page-link"
              className="group mt-14 inline-flex items-center gap-2 rounded-full border border-[#86C89B]/40 px-6 py-3.5 text-sm text-[#FCFBF7] hover:bg-[#86C89B] hover:text-[#0F2317] transition-colors">
              Scopri il nostro metodo in 6 passi <ArrowUpRight size={15} className="transition-transform duration-300 group-hover:rotate-45" />
            </Link>
          </Reveal>
        </div>
        <Reveal className="lg:col-span-4 lg:col-start-9 lg:sticky lg:top-32" delay={0.2}>
          <Breathing />
        </Reveal>
      </div>
    </div>
  </section>
);
